import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {usePlayerValidators} from './usePlayerValidators'
import {MechanicValidatorDevelopmentCard} from '@colonist/game-mechanic-validators'
import {useMapValidator} from './useMapValidator'
import {useCurrentStateValidator} from './useCurrentStateValidator'

export const useMechanicValidatorDevelopmentCard = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const currentStateValidator = useCurrentStateValidator()
    const mechanicDevelopmentCardsState = useGameStore((state) => state.gameState.mechanicDevelopmentCardsState)

    return useMemo(() => {
        if(!mechanicDevelopmentCardsState) return undefined
        return new MechanicValidatorDevelopmentCard(playerValidators, mapValidator, currentStateValidator, mechanicDevelopmentCardsState)
    }, [playerValidators, mapValidator, currentStateValidator, mechanicDevelopmentCardsState])
}
